import { RESOURCE } from '@src/constants';
import { omitIsNil } from '@src/utils/omit';
import { API_URL } from '@src/configs';
import api from './api';

const getFavouriteVoices = async ({
  search,
  searchFields,
  language,
  sort,
  region,
  category,
  ageGroup,
  gender,
  lang,
  locale,
  hasDubbing,
}) => {
  const params = omitIsNil({
    search,
    searchFields,
    language,
    sort,
    region,
    category,
    ageGroup,
    gender,
    lang,
    locale,
    hasDubbing,
  });

  const response = await api({
    method: 'GET',
    url: `${API_URL}/api/v1${RESOURCE.FAVOURITE_VOICES}`,
    params,
  });
  return response;
};

const updateFavouriteVoices = async ({ voiceCode, action }) => {
  const response = await api({
    method: 'POST',
    url: `${API_URL}/api/v1${RESOURCE.FAVOURITE_VOICES}`,
    data: { voiceCode, action },
  });

  return response;
};

export { getFavouriteVoices, updateFavouriteVoices };
